import { axios } from "@sdk/axios";
import type {
  AllocatedProfitBreakdownResponse,
  PerformanceByAgentResponse,
  PerformanceByBookingPeriodResponse,
  PerformanceByDestinationResponse,
  PerformanceByMarketingResponse,
  PerformanceDailyActivityResponse,
  PerformanceMarketingGroupBy,
  PerformanceReportFilters,
  PerformanceSummaryResponse,
} from "./performance-report.models";

export class PerformanceReportServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.performance.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.performance = new PerformanceReportApi(config);
  }

  performance!: PerformanceReportApi;
}

class PerformanceReportApi {
  constructor(protected config: { basePath: string; token: string }) {}

  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }

  private post<T>(path: string, body: Record<string, unknown>) {
    return axios
      .post<T>(this.config.basePath + path, body, {
        headers: { Authorization: this.config.token },
      })
      .then((res) => res.data);
  }

  summary = (filters: PerformanceReportFilters) =>
    this.post<PerformanceSummaryResponse>("/reports/performance/summary", filters);

  allocatedProfitBreakdown = (filters: PerformanceReportFilters) =>
    this.post<AllocatedProfitBreakdownResponse>(
      "/reports/performance/allocated-profit-breakdown",
      filters
    );

  byAgent = (filters: PerformanceReportFilters) =>
    this.post<PerformanceByAgentResponse>("/reports/performance/by-agent", filters);

  byMarketing = (
    filters: PerformanceReportFilters & { groupBy: PerformanceMarketingGroupBy }
  ) =>
    this.post<PerformanceByMarketingResponse>(
      "/reports/performance/by-marketing",
      filters
    );

  byBookingPeriod = (filters: PerformanceReportFilters) =>
    this.post<PerformanceByBookingPeriodResponse>(
      "/reports/performance/by-booking-period",
      filters
    );

  byDestination = (filters: PerformanceReportFilters) =>
    this.post<PerformanceByDestinationResponse>(
      "/reports/performance/by-destination",
      filters
    );

  dailyActivity = (filters: PerformanceReportFilters) =>
    this.post<PerformanceDailyActivityResponse>(
      "/reports/performance/daily-activity",
      filters
    );
}
